import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwipeDownAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"swipe_down_alt"}/>
}
